import findKey from "lodash/findKey"
import { isClient } from "common/helper"
import { cleanEnv, str } from "envalid"

// console.log("process.env", process.env)

export const envConfig = cleanEnv(process.env, {
  REACT_APP_ENV: str(),
  REACT_APP_VERSION: str(),
  REACT_APP_DEFAULT_LANG: str(),
  NODE_ENV: str(),
})

const config = {
  demo: {
    HOST: "https://flex.demo.zennite.co",
    API_ENDPOINT: "https://flex-api.demo.zennite.co/graphql",
    API: "https://flex-api.demo.zennite.co",
  },
  production: {
    HOST: "https://flex.prod.zennite.co",
    API_ENDPOINT: "https://flex-api.prod.zennite.co/graphql",
    API: "https://flex-api.prod.zennite.co",
  },
  uat: {
    HOST: "https://flex.uat.zennite.co",
    API_ENDPOINT: "https://flex-api.uat.zennite.co/graphql",
    API: "https://flex-api.uat.zennite.co",
  },
  dev: {
    HOST: "https://flex.dev.zennite.co",
    API_ENDPOINT: "https://flex-api.dev.zennite.co/graphql",
    API: "https://flex-api.dev.zennite.co",
  },
  staging: {
    HOST: "https://dev-scg2-flex-app.moveplus.dynu.net",
    API_ENDPOINT: "https://dev-scg2-flex-app.moveplus.dynu.net/graphql",
    API: "https://dev-scg2-flex-api.moveplus.dynu.net",
  },
  staging2: {
    HOST: "http://localhost:9903",
    API_ENDPOINT: "http://localhost:9901/graphql",
    API: "http://localhost:9901",
  },
  staging3: {
    HOST: "https://dev-scg-my-benefit-app.moveplus.dynu.net",
    API_ENDPOINT: "https://dev-scg-my-benefit-app.moveplus.dynu.net/graphql",
    API: "https://dev-scg-my-benefit-api.moveplus.dynu.net",
  },
  staging4: {
    HOST: "https://dev-scg1-my-benefit-app.moveplus.dynu.net",
    API_ENDPOINT: "https://dev-scg1-my-benefit-app.moveplus.dynu.net/graphql",
    API: "https://dev-scg1-my-benefit-api.moveplus.dynu.net",
  },
  development: {
    HOST: "http://host.docker.internal:22903",
    API_ENDPOINT: "http://host.docker.internal:22901/graphql",
    API: "http://host.docker.internal:22901",
  },
  development2: {
    HOST: "http://localhost:22903",
    API_ENDPOINT: "http://localhost:22901/graphql",
    API: "http://localhost:22901",
  },
}

export const getEnvByHost = () => (isClient ? findKey(config, { HOST: window.location.origin }) : null)

export const env = getEnvByHost() || "demo"

console.log("ENV : ", getEnvByHost())
console.log("HOST : ", window.location.origin)
console.log("GET HOST : ", config[env].HOST)

const backofficeEnvConfig = {
  demo: {
    HOST: "https://flex-backoffice.demo.zennite.co",
    API_ENDPOINT: "https://flex-api.demo.zennite.co/graphql",
    API: "https://flex-api.demo.zennite.co",
  },
  production: {
    HOST: "https://flex-backoffice.prod.zennite.co",
    API_ENDPOINT: "https://flex-api.prod.zennite.co/graphql",
    API: "https://flex-api.prod.zennite.co",
  },
  uat: {
    HOST: "https://flex-backoffice.uat.zennite.co",
    API_ENDPOINT: "https://flex-api.uat.zennite.co/graphql",
    API: "https://flex-api.uat.zennite.co",
  },
  dev: {
    HOST: "https://flex-backoffice.dev.zennite.co",
    API_ENDPOINT: "https://flex-api.dev.zennite.co/graphql",
    API: "https://flex-api.dev.zennite.co",
  },
  staging: {
    HOST: "https://dev-scg2-flex-backoffice.moveplus.dynu.net",
    API_ENDPOINT: "https://dev-scg2-flex-backoffice.moveplus.dynu.net/graphql",
    API: "https://dev-scg2-flex-api.moveplus.dynu.net",
  },
  staging2: {
    HOST: "http://localhost:9903",
    API_ENDPOINT: "http://localhost:9901/graphql",
    API: "http://localhost:9901",
  },
  staging3: {
    HOST: "https://dev-scg-my-benefit-backoffice.moveplus.dynu.net",
    API_ENDPOINT: "https://dev-scg-my-benefit-backoffice.moveplus.dynu.net/graphql",
    API: "https://dev-scg-my-benefit-api.moveplus.dynu.net",
  },
  staging4: {
    HOST: "https://dev-scg1-my-benefit-backoffice.moveplus.dynu.net",
    API_ENDPOINT: "https://dev-scg1-my-benefit-backoffice.moveplus.dynu.net/graphql",
    API: "https://dev-scg1-my-benefit-api.moveplus.dynu.net",
  },
  development: {
    HOST: "http://host.docker.internal:22902",
    API_ENDPOINT: "http://host.docker.internal:22901/graphql",
    API: "http://host.docker.internal:22901",
  },
  development2: {
    HOST: "http://localhost:22902",
    API_ENDPOINT: "http://localhost:22901/graphql",
    API: "http://localhost:22901",
  },
}

export const backofficeEnv = backofficeEnvConfig[env]

export default config[env]
